//#region src/link.ts
const preloadWarning = "Error preloading route! ☝️";
//#endregion
export { preloadWarning };

//# sourceMappingURL=link.js.map